<template>
  <div class="picker-goods">
    <SpFinder ref="finder" reserve-selection :row-key="rowKey" :url="url" fixed-row-action :setting="setting"
      row-actions-width="100" :other-config="{ 'max-height': '730' }" :hooks="{
        beforeSearch: beforeSearch,
        afterSearch: afterSearch
      }" @select-all="handleSelectAll" @select="handleSelectAll">
    </SpFinder>

    <ImportDialog ref="importAddDialog" v-show="false" buttonName="导入" buttonSize="medium" fileName="导入"
      fileType="upload_aftersales_product_store_return_setting" @closeDialog="refresh"/>
  </div>
</template>

<script>
import { createSetting } from '@shopex/finder'
import { listUrl, deleteAftersales, updateAftersales } from './api'
import ImportDialog from '@/components/importDialog'


export default {
  components: {
    ImportDialog
  },
  data() {
    return {
      url: listUrl,
      rowKey: 'item_id',
      checkedList: [],
    }
  },
  computed: {
    setting() {
      return createSetting({
        search: [
          { name: '商品名称', key: 'item_name' },
          { name: '商品货号', key: 'item_bn' }
        ],
        columns: [
          { name: '商品ID', key: this.rowKey, width: 100 },
          {
            name: '商品名称',
            key: 'item_name',
          },
          {
            name: '商品货号',
            key: 'item_bn',
          },
          {
            name: '商品规格',
            key: 'item_spec_desc',
          },
          {
            name: '启用',
            key: 'item_name',
            render: (h, { row }) => {
              console.log("🚢 ~ 当前打印的内容 ~ row:aaaaaaaaaaaaaaaaaaaaaaa", row);

              return <el-switch
                v-model={row.status}
                active-value='1'
                inactive-value='0'
                on-change={() => this.switchChange(row)}
                >
              </el-switch>
            }
          },
        ],
        actions: [
          {
            name: '导入',
            key: 'add',
            slot: 'header',
            type: 'button',
            buttonType: 'primary',
            size: 'small',
            action: {
              handler: () => {
                this.openImportAddDialog()
              }
            }
          },
          {
            name: '批量删除',
            key: 'add',
            slot: 'header',
            type: 'button',
            buttonType: 'primary',
            size: 'small',
            action: {
              handler: () => {
                this.onBatchDelete()
              }
            }
          },
        ]
      })
    }
  },
  mounted() {

  },
  methods: {
    handleSelectAll(list) {
      this.checkedList = list
    },
    onBatchDelete() {
      if (this.checkedList.length === 0) {
        this.$message.error('请选择要删除的商品')
        returnid
      }
      const ids = this.checkedList.map(item => item.id)
      this.onDeleteGiftordergoods(ids.join(','))
    },
    onDeleteGiftordergoods(v) {
      deleteAftersales({id: v}).then(() => {
        this.refresh()
      })
    },
    beforeSearch(params) {
      params = {
        ...params,
        page_size: params.pageSize,
      }
      delete params.pageSize
      return params
    },
    afterSearch(params) {
    },
    refresh() {
      this.$refs.finder.refresh()
    },
    openImportAddDialog() {
      this.$refs.importAddDialog.visible = true
    },
    // 启用开关
    switchChange(row) {
      let params = {
        id: row.id,
        status: row.status
      }
      updateAftersales(params).then(() => {
        this.refresh()
      })
    }
  }
}
</script>
<style scoped type="text/css" lang="scss">
.form-search {
  margin-bottom: 10px;
}

.form-name {
  width: 200px !important;
}
</style>
